
import * as PE91cnNoZWxmLmNvcmU6YXBpPg from './Ourshelf-core-api.mjs';
import * as PE91cnNoZWxmLmNvcmU6bW9kZWw_ from './Ourshelf-core-model.mjs';
import * as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg from './androidx-compose-runtime-runtime.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5mb3VuZGF0aW9uOmZvdW5kYXRpb24tbGF5b3V0Pg from './compose-multiplatform-core-compose-foundation-foundation-layout.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5mb3VuZGF0aW9uOmZvdW5kYXRpb24_ from './compose-multiplatform-core-compose-foundation-foundation.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDptYXRlcmlhbC1pY29ucy1jb3JlPg from './compose-multiplatform-core-compose-material-material-icons-core-wasm-js.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDptYXRlcmlhbC1pY29ucy1leHRlbmRlZD4 from './compose-multiplatform-core-compose-material-material-icons-extended-wasm-js.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDM6bWF0ZXJpYWwzPg from './compose-multiplatform-core-compose-material3-material3-wasm-js.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS1ncmFwaGljcz4 from './compose-multiplatform-core-compose-ui-ui-graphics.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS10ZXh0Pg from './compose-multiplatform-core-compose-ui-ui-text.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS11bml0Pg from './compose-multiplatform-core-compose-ui-ui-unit.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aT4 from './compose-multiplatform-core-compose-ui-ui.mjs';
import * as PGtvdGxpbj4 from './kotlin-kotlin-stdlib.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4 from './kotlinx-coroutines-coreWasm.mjs';
import { __ALL_EXPORTS as PE91cnNoZWxmLmNvcmU6YXBpPg__ALL_EXPORTS } from './Ourshelf-core-api.mjs';
import { __ALL_EXPORTS as PE91cnNoZWxmLmNvcmU6bW9kZWw___ALL_EXPORTS } from './Ourshelf-core-model.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg__ALL_EXPORTS } from './androidx-compose-runtime-runtime.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5mb3VuZGF0aW9uOmZvdW5kYXRpb24tbGF5b3V0Pg__ALL_EXPORTS } from './compose-multiplatform-core-compose-foundation-foundation-layout.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5mb3VuZGF0aW9uOmZvdW5kYXRpb24___ALL_EXPORTS } from './compose-multiplatform-core-compose-foundation-foundation.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDptYXRlcmlhbC1pY29ucy1jb3JlPg__ALL_EXPORTS } from './compose-multiplatform-core-compose-material-material-icons-core-wasm-js.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDptYXRlcmlhbC1pY29ucy1leHRlbmRlZD4__ALL_EXPORTS } from './compose-multiplatform-core-compose-material-material-icons-extended-wasm-js.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDM6bWF0ZXJpYWwzPg__ALL_EXPORTS } from './compose-multiplatform-core-compose-material3-material3-wasm-js.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS1ncmFwaGljcz4__ALL_EXPORTS } from './compose-multiplatform-core-compose-ui-ui-graphics.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS10ZXh0Pg__ALL_EXPORTS } from './compose-multiplatform-core-compose-ui-ui-text.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS11bml0Pg__ALL_EXPORTS } from './compose-multiplatform-core-compose-ui-ui-unit.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aT4__ALL_EXPORTS } from './compose-multiplatform-core-compose-ui-ui.mjs';
import { __ALL_EXPORTS as PGtvdGxpbj4__ALL_EXPORTS } from './kotlin-kotlin-stdlib.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4__ALL_EXPORTS } from './kotlinx-coroutines-coreWasm.mjs';
import { __TAG as wasmTag, getCachedJsObject } from './kotlin-kotlin-stdlib.mjs'

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const js_code = {

}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export const importObject = {
    js_code,
    intrinsics: {

        tag: wasmTag
    },
    "'": StringConstantsProxy,
    '<kotlin>': PGtvdGxpbj4__ALL_EXPORTS,
    '<androidx.compose.runtime:runtime>': PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg__ALL_EXPORTS,
    '<Ourshelf.core:api>': PE91cnNoZWxmLmNvcmU6YXBpPg__ALL_EXPORTS,
    '<org.jetbrains.compose.ui:ui>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aT4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-coroutines-core>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4__ALL_EXPORTS,
    '<org.jetbrains.compose.ui:ui-unit>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS11bml0Pg__ALL_EXPORTS,
    '<org.jetbrains.compose.ui:ui-graphics>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS1ncmFwaGljcz4__ALL_EXPORTS,
    '<org.jetbrains.compose.ui:ui-text>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aS10ZXh0Pg__ALL_EXPORTS,
    '<org.jetbrains.compose.foundation:foundation-layout>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS5mb3VuZGF0aW9uOmZvdW5kYXRpb24tbGF5b3V0Pg__ALL_EXPORTS,
    '<org.jetbrains.compose.material3:material3>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDM6bWF0ZXJpYWwzPg__ALL_EXPORTS,
    '<org.jetbrains.compose.foundation:foundation>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS5mb3VuZGF0aW9uOmZvdW5kYXRpb24___ALL_EXPORTS,
    '<Ourshelf.core:model>': PE91cnNoZWxmLmNvcmU6bW9kZWw___ALL_EXPORTS,
    '<org.jetbrains.compose.material:material-icons-core>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDptYXRlcmlhbC1pY29ucy1jb3JlPg__ALL_EXPORTS,
    '<org.jetbrains.compose.material:material-icons-extended>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS5tYXRlcmlhbDptYXRlcmlhbC1pY29ucy1leHRlbmRlZD4__ALL_EXPORTS,
};
    